<i18n
  src="@/locales/views/agro_exporter/quality_reports/process/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>

<template>
  <go-back-link
    :text="$t('labels.go_back_link')"
    :name="routeName('')"
    :params="{
      agro_exporter_id: agro_exporter_id
    }"
  ></go-back-link>

  <bread-crumbs
    :labels="[module_name, agro_exporter_process.name]"
  ></bread-crumbs>

  <template v-if="load_data_general">
    <tabs-container v-model="option_tabs" :with_routing="true" />

    <router-view
      :agro_exporter_id="agro_exporter_id"
      :agro_exporter_process_id="agro_exporter_process_id"
    ></router-view>
  </template>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_reports/process/show_process.js";

export default {
  name: "AEQualityReportsProcessShowProcess",
  props: ["agro_exporter_id", "agro_exporter_process_id"],
  data() {
    return {
      load_data_general: false,
      agro_exporter_process: {},
      option_tabs: []
    };
  },
  methods: {
    fetchAgroExporterProcess: async function () {
      let response = await Requester.fetchAgroExporterProcess(
        this.agro_exporter_id,
        this.agro_exporter_process_id
      );
      this.agro_exporter_process = response.data;
      this.load_data_general = true;
    },

    fillOptions: function () {
      this.option_tabs = [
        {
          name: "Resumen",
          icon: "fa-solid fa-chart-pie",
          route: { name: this.routeName("show_process_summary") }
        },
        {
          name: "Semanal",
          icon: "fa-solid fa-chart-line",
          route: { name: this.routeName("show_process_weekly") }
        },
        {
          name: "Trimestral",
          icon: "fa-solid fa-calendar-alt",
          route: { name: this.routeName("show_process_quarterly") }
        }
      ];
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => {
        this.fillOptions();
        this.fetchAgroExporterProcess();
      })
    );
  }
};
</script>
